<template>
  <div
    :class="[
      padless ? '' : 'bordered-section',
      $vuetify.rtl ? 'bordered-right' : 'bordered-left',
      `bordered-section${sectionNumber}`,
      mainSection ? 'bordered-top' : '',
      thickBorder
        ? $vuetify.rtl
          ? 'bordered-right-thick'
          : 'bordered-left-thick'
        : ''
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    sectionNumber: {
      type: Number,
      required: true
    },
    padless: {
      type: Boolean,
      default: false
    },
    mainSection: {
      type: Boolean,
      default: false
    },
    thickBorder: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
</style>